import { postUpdateExchangeRates } from '../api/postUpdateExchangeRates';

const setPostUpdateExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateExchangeRates(params);
            window.location.replace('/settings/exchange-rates');
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateExchangeRates
}